import { Component } from "@angular/core";

@Component({
    selector: 'navbar',
    providers: [],
    template: `
    <h2>navbar place</h2>
    `
})
export class Navbar {
    constructor() {
    }
}
